import { getCmsJourneyPlanner } from "../../../app/api/getCmsJourneyPlanner";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsJourneyPlanner } from "../../../Orchestrator/Types/Index";

class GetCmsJourneyPlannerAction extends BaseAction<ICmsJourneyPlanner | null, void> {
  override async run(): Promise<ICmsJourneyPlanner | null> {
    let result: ICmsJourneyPlanner | null = null;
    try {
      const response = await getCmsJourneyPlanner();

      if (response.status === "ok" && response.answer) {
        result = response.answer.data ?? null;
      } else {
        console.warn("Failed to fetch journey planner content.");
      }
    } catch (error: any) {
      console.error("Error fetching journey planner content:", error);
    } finally {
      updateRecoilState("journeyPlannerContentAtom", result);
      return result;
    }
  }
}

export const getCmsJourneyPlannerAction = new GetCmsJourneyPlannerAction();
